var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_cancel",
    "data-name": " cancel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.376,
    height: 45.376,
    viewBox: "0 0 45.376 45.376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 45.376,
    height: 45.376,
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)",
    opacity: 0.871
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18.969,37.938A18.969,18.969,0,1,1,37.938,18.97,18.99,18.99,0,0,1,18.969,37.938Zm0-16.295h0l5.48,5.48a1.889,1.889,0,0,0,2.674,0,1.932,1.932,0,0,0,0-2.675l-5.482-5.482,5.482-5.481a1.891,1.891,0,1,0-2.674-2.675l-5.482,5.481-5.482-5.481a1.892,1.892,0,1,0-2.675,2.675l5.482,5.481L10.812,24.45a1.892,1.892,0,1,0,2.675,2.675l5.48-5.48Z",
    transform: "translate(3.719 3.719)",
    fill: "#f76868"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.4265db22aa3832a9aa8ab32992ba70ac.svg";
export { ForwardRef as ReactComponent };